export enum IssueDetailPanelTabs {
  Details = "details",
  ActivityLog = "activitylog",
  CustomTab = "custom-tab",
}
